/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
// eslint-disable-next-line simple-import-sort/imports
import { ApiActions } from '@orientaction/api-actions';
import { Switch } from '@orientaction/commons';
import { TabPanel, TableContent } from '@orientaction/components';
import { useAdminUser } from '@orientaction/hooks';
import { formatData, getFromLS } from '@orientaction/utils';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Result from './Result';
import { useNavigation } from '../../Context/NavigationContext';

interface IListTabsAdmin {
  typeTestChecked?: any;
}

const ListTabsAdmin: FC<IListTabsAdmin> = ({ typeTestChecked }) => {
  const {
    actived,
    tabs,
    company,
    countTabs,
    textFilter,
    loadingList,
    listAdminUser,
    listAdminPanel,
    currentPagination,
    rattachement,
    setActived,
    setCurrentPagination,
    onDelete,
    oneDisable,
    setCurrent,
    setOpenDrawer,
    getAdminUserList,
    setListUphierchy,
    setRattachement,
    getAdminUserListZoneInfluance,
  } = useAdminUser();

  const dispatch = useDispatch();
  const refetch = useSelector((state: any) => state?.api?.refetch);
  const { setPage } = useNavigation();

  const userConnected = JSON.parse(getFromLS('userInfos') || '{}');
  const isUserConsultant = userConnected?.company_user_role?.id === 4;

  const history = useHistory();

  const columnsForRole = (colom: any[]) => {
    if (!isUserConsultant) {
      return colom;
    }

    return (colom || []).map((col: any) => {
      if (col.type !== 'action') {
        return col;
      }

      return {
        ...col,
        header: (col.header || []).map((h: any) => ({
          ...h,
          option: {
            ...h.option,
            listAction: (h.option?.listAction || []).filter(
              (action: string) => action !== 'delete',
            ),
          },
        })),
      };
    });
  };

  const onEdit = (data: any) => {
    if (tabs === 5) {
      history.push(`/admin/users-resultats/beneficiaire/${data.id}`);
      return;
    }

    if (data.isHierarchy) {
      setListUphierchy([
        data.upper_hierarchy?.data
          ? {
              ...data.upper_hierarchy.data.attributes,
              id: data.upper_hierarchy.data.id,
            }
          : null,
      ]);
      setCurrent({
        ...data,
        company: company as number,
        company_user_role: data.company_user_role?.data?.id || '',
        upper_hierarchy: data.upper_hierarchy?.data?.id || '',
        name_upper_hierarchy: `${data.upper_hierarchy?.data?.attributes?.firstname} ${data.upper_hierarchy?.data?.attributes?.lastname}`,
        isView: !!data.isView,
        isUpdate: true,
      });
      setOpenDrawer(true);
      return;
    }

    history.push(`/admin/users-resultats/consultant/${data.id}`);
  };

  const updateUserRattachedFilter = (e: any) => {
    // update user admin rattached flag in store
    setRattachement(e.target.checked);
    dispatch(ApiActions.setRefetch(true));
  };

  const updateUserActiveFilter = (e: any) => {
    // update user admin active flag in store
    setActived(e.target.checked);
    dispatch(ApiActions.setRefetch(true));
  };

  const handleChangePage = (event: any, newPage: number) => {
    setCurrentPagination(newPage);

    if (userConnected?.role?.type !== 'admin') {
      getAdminUserListZoneInfluance(
        userConnected.id,
        tabs,
        newPage,
        textFilter,
        actived,
        rattachement,
      );
    }

    if (userConnected?.role?.type === 'admin') {
      getAdminUserList(company, tabs, newPage, textFilter, actived, rattachement);
    }
    setPage(newPage);
  };

  const btnClick = (data: any, key: any) => {
    if (key === 'subordinates') {
      history.push(`/admin/users-resultats/consultant/${data.id}?tab=beneficiaires`);
      return;
    }

    if (key === 'viewTest') {
      history.push(`/admin/users-resultats/beneficiaire/${data.id}?tab=resultats-tests`);
    }

    if (key === 'ressource') {
      history.push(`/admin/ressources-beneficiaire/${data.id}`);
    }
    if (key === 'assistantIA') {
      history.push(`/admin/assistant-ia/${data.id}`);
    }

    if (key === 'firstname' || key === 'lastname') {
      if (tabs === 5) {
        history.push(`/admin/users-resultats/beneficiaire/${data.id}`);
        return;
      }
      history.push(`/admin/users-resultats/consultant/${data.id}`);
    }
  };
  const adminUserId = [1, 2, 3];

  return (
    <>
      <div
        style={{
          marginTop: '20px',
          marginBottom: '20px',
        }}
      >
        {tabs !== 6 && (
          <Switch
            checked={!!actived}
            onChange={updateUserActiveFilter}
            label="Utilisateurs actifs"
            cy="user-actif"
          />
        )}

        {tabs === 5 &&
          company === 1 &&
          (userConnected?.role?.type === 'admin' ||
            adminUserId.includes(userConnected?.company_user_role?.id)) && (
            <Switch
              checked={rattachement}
              onChange={updateUserRattachedFilter}
              label="Utilisateurs rattachés"
              cy="user-rattache"
            />
          )}

        <div
          style={{
            marginTop: '10px',
            marginBottom: '20px',
          }}
        >
          {/*
           *
           * listAdminPanel
           *
           * in Component/AdminTab
           *
           * seter
           *
           */}

          {listAdminPanel.map((item: any, index: number) => {
            if (!item.viewNbr) {
              return (
                <TabPanel value={tabs} index={6} key={`${item.userTypeConnected}`}>
                  <Result typeTestChecked={typeTestChecked} company={company} />
                </TabPanel>
              );
            }

            return (
              <>
                <TabPanel
                  value={tabs}
                  index={item.userTypeConnected}
                  key={`${item.userTypeConnected}`}
                >
                  <TableContent
                    loading={loadingList}
                    bgColor="#23296F"
                    array={formatData(listAdminUser, item.userTypeConnected, rattachement)}
                    coulom={columnsForRole(item.colomTable)}
                    oneEdit={onEdit}
                    oneDisable={oneDisable}
                    onDelete={isUserConsultant ? undefined : onDelete}
                    btnClick={btnClick}
                    variant={item.userTypeConnected !== 6 ? 'hierarchy' : 'default'}
                    pagination={{
                      count: countTabs[item?.userTypeConnected] || 0,
                      onChangePage: handleChangePage as any,
                      page: +currentPagination as number,
                      rowsPerPage: 10,
                    }}
                  />
                </TabPanel>
              </>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ListTabsAdmin;
